export const CANCELLATION_POLICY = "Cancellation Policy";
export const FUEL_POLICY = "Fuel Policy";
